<template>
    <quill-editor
        ref="editor"
        class="message-quill-editor"
        :value="value"
        @input="c => { this.$emit('input', c) }"
        @ready="onEditorReady($event)"
        :options="quillConfiguration"
        :disabled="disabled"
    />
</template>

<script>
    import 'quill/dist/quill.core.css'
    import 'quill/dist/quill.snow.css'
    import 'quill/dist/quill.bubble.css'

    import Quill from 'quill'
    // import { quillEditor } from 'vue-quill-editor'
    import quillEditor from '../../../ts/Quill/Editor.vue'


    // Change default wrapping tag from 'p' to 'div'.
    var Block = Quill.import('blots/block');
    Block.tagName = 'div';
    Quill.register(Block);

    const quillConfiguration = {
        components: { quillEditor },
        placeholder: "Write here...",
        modules: {
            toolbar: [
              ['bold', 'italic', 'underline', 'strike'],
              [{ 'list': 'ordered'}, { 'list': 'bullet' }],
              ['clean']
            ]
        }
    }

    export default {
        components: { quillEditor },
        props: {
            value: {
                type: String,
                required: true
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        mounted() {
            // Change the toolbar / editor ordering to fix tab ordering.
            let editor = this.$refs.editor.$el.querySelector('.ql-container')
            let toolbar = this.$refs.editor.$el.querySelector('.ql-toolbar')
            editor.after(toolbar)
        },
        methods: {
            onEditorReady(quill) {
                quill.focus()
                this.$emit('ready')
            }
        },
        data() {
            return {
                quillConfiguration,
            }
        }
    }
</script>

<style lang="scss">
    .message-quill-editor {
        position: relative;

        .ql-toolbar {
            position: absolute;
            bottom: 0;
            width: 100%;
            border-left: none;
            border-right: none;
        }

        .ql-container {
            border: none;
            font-size: 16px;

            .ql-editor {
                padding: 0 0 50px 0;
                &.ql-blank::before {
                    left: 0;
                    font-style: normal;
                }
            }
        }
    }
</style>